export const WorkData = [
	{
		title: "Guide Genie",
		desc: "Web app to recommend a Professor to a student from a network of professors looking for a mentor or a guide.",
		tech: ["Python", "streamlit", "gemini-ai", "Pandas", "BERT", "scholarly", "sklearn"],
		gitlink: "//github.com/shrutivarade/GuideGenie/",
		site: "//guide-genie.streamlit.app/",
		disclaimer: "Please note that this is confidential and live client project that I worked on during my tenure.",
	},
	{
		title: "EASY/RisQ",
		desc: "A large data-driven web application integrating the EASY/RisQ model (Credit Risk) for Banks and Exchanges that generates default probability for the companies.",
		tech: ["Python", "Django", "Pandas", "JS", "CSS", "HTML", "Kafka", "AWS", "MariaDB"],
		gitlink: "#",
		site: "",
		confidential: true,
		disclaimer: "Please note that this is confidential and live client project that I worked on during my tenure.",
	},
	{
		title: "Ad Revenue Optimizer",
		desc: "ARO is a web-based application for optimizing revenue generated by a broadcaster's advertisement slot inventory, automating bid management and execution",
		tech: ["Java", "JSP", "JS", "Bootstrap", "JQuery", "CSS", "HTML", "Plotly", "MSSQL"],
		gitlink: "#",
		site: "",
		confidential: true,
		disclaimer: "Please note that this is confidential and live client project that I worked on during my tenure.",
	},
	{
		title: "Circle detection using Hough Transform",
		desc: "Computer vision application - circle detection, a project for circle detection using hough transform.",
		tech: ["Python", "OpenCV", "Numpy"],
		gitlink: "//www.github.com/navkar98/cv-coursework",
		site: "",
	},
	{
		title: "Design Patterns Demo",
		desc: "Demonstrated object-oriented design patterns Singleton, State, Template, Composite, Proxy, Visitor, Strategy, Observer patterns using Java",
		tech: ["Java", "Design Pattern", "JUnit5"],
		gitlink: "//github.com/navkar98/design-pattern-demo",
		site: "",
	},
	{
		title: "Object & Face recognization",
		desc: "Neural network application - object & face recognization, trained and tested CNN model using keras and tensorflow on cifar10 and face dataset.",
		tech: ["Python", "Keras", "TensorFlow", "Numpy"],
		gitlink: "//www.github.com/navkar98/nn-coursework.git",
		site: "",
	},
	{
		title: "Shoe Store",
		desc: "The shoe store is an online web application created using Java, jsp pages, and servlets. It offers solution to buy shoes from different brands and companies at a single place.",
		tech: ["Java", "JSP", "Servlets", "Apache Maven", "Oracle"],
		gitlink: "//github.com/navkar98/shoe-store",
		site: "",
	},
	{
		title: "Simple Django Project",
		desc: "A simple and basic example of django app which includes reading of data from database and creates pdf.",
		tech: ["Django", "Python", "AWS", "Apache Kafka", "SQLite3"],
		gitlink: "//github.com/navkar98/simple-django-project",
		site: "",
	},
	{
		title: "Simple Data Visualizer",
		desc: "A flask app which contains api's consisting of data. Data is used to show various graphs using matplotlib.",
		tech: ["Flask", "Python", "Matplotlib", "SQLite3"],
		gitlink: "//github.com/navkar98/simple-data-visualizer",
		site: "",
	},
	{
		title: "Simple React App",
		desc: "A sample react app for a cafe to showcase various food cuisine/dishes.",
		tech: ["React.js", "Css", "HTML"],
		gitlink: "//www.github.com/navkar98/simple-react-app",
		site: "",
	},
	{
		title: "Witchar17",
		desc: "WITchar is a National Level Technical Symposium organized by Walchand Institute of Technology, Solapur. It is being held every year since 2007. This is repo for the mobile application built for year 2017.",
		tech: ["Java", "XML", "Android",],
		gitlink: "//github.com/navkar98/witchar17",
		site: "",
	},
	// {
	// 	title: "Instablog",
	// 	desc: "A blog website where you can post your ideas and view those of others",
	// 	tech: ["React.js", "Firebase"],
	// 	gitlink: "//www.github.com/Pappyjay23/instablog",
	// 	site: "//instablog-v1.netlify.app/",
	// },
];
